import * as angular from "angular";
import {IController} from "angular";
import * as _ from "lodash";
import {BringozLoaderService} from "../../../commons/services/bringoz-loader.service";
import {PricePlanAlertsService} from "../../services/price-plan-alerts.service";
import {PricePlanBundleRequestsService} from "../../services/price-plan-bundle-requests.service";
import {PricePlanDialogService} from "../../services/price-plan-dialog-service.service";

export class BillingPricePlanViewComponent implements IController {
  pricePlanBundle: any;
  selectedProgramId: any;
  accountId: any;

  $stateRef: any;
  enabledPrograms: any;

  constructor(private $log, private bringozLoaderService: BringozLoaderService, private $state, private pricePlanDialogService: PricePlanDialogService,
              private pricePlanBundleRequestsService: PricePlanBundleRequestsService, private pricePlanAlertsService: PricePlanAlertsService) {
  }

  $onInit() {
    this.$stateRef = this.$state;
    this.enabledPrograms = this.getProgramMenu(this.pricePlanBundle.entryList, this.selectedProgramId);
  }

  // ******************************
  //        Public methods
  // ******************************

  onEditBundle(event) {
    this.pricePlanDialogService.editProgram(event, this.pricePlanBundle)
      .then((updatedBundle) => {
        this.updatePricePlanBundle(updatedBundle);
      })
      .catch(() => {
        this.$log.info('Dialog Closed')
      })
  }

  onCreateChild(pricePlanBundle, event) {
    this.pricePlanDialogService.createChildPricePlan(event)
      .then((data) => {
        const payload = {
          name: data.name,
          parentId: this.pricePlanBundle.id
        };
        this.createChildBundle(payload);
      })
      .catch(() => {
        this.$log.info('Dialog Closed')
      })
  }

  // ******************************
  //        Private methods
  // ******************************

  private createChildBundle(payload) {
    this.pricePlanBundleRequestsService.createBundle(payload)
      .then((bundle) => {
        this.pricePlanAlertsService.createSuccess();
        const bundleId = _.get(bundle, 'id');
        if (bundleId) {
          this.$state.go('pricePlanDetails', {pricePlanBundleId: bundleId});
        }
      })
  }

  private getProgramMenu(programs, selectedProgramId?) {
    const enabledPrograms = _.filter(programs, (program) => {
      return program.enabled;
    });

    return _.map(enabledPrograms, (p) => {
      return {
        name: p.name,
        type: p.type,
        parentProgramName: p.parentProgramName,
        parentProgramId: p.parentProgramId,
        id: p.id,
        open: p.id === selectedProgramId
      }
    });
  }

  private updatePricePlanBundle(updatedBundle) {
    this.bringozLoaderService.on();
    this.pricePlanBundleRequestsService.editBundle(this.pricePlanBundle.id, updatedBundle, this.accountId)
      .then((updatedPricePlanBundle) => {
        this.pricePlanBundle = updatedPricePlanBundle;
        this.enabledPrograms = this.getProgramMenu(updatedPricePlanBundle.entryList);
        this.pricePlanAlertsService.updateSuccess();
      })
      .catch(() => {
        this.pricePlanAlertsService.updateError();
      })
      .finally(() => {
        this.bringozLoaderService.off();
      })
  }

  private createProgramType(childBundle) {
    this.bringozLoaderService.on();
    this.pricePlanBundleRequestsService.createBundle(childBundle)
      .then(() => {
        this.pricePlanAlertsService.createSuccess();
        //TODO maybe redirect to new child bundle?
      })
      .catch(() => {
        this.pricePlanAlertsService.createError();
      })
      .finally(() => {
        this.bringozLoaderService.on();
      })
  }


}

angular
  .module('bringoz.admin.pricePlan')
  .component('billingPricePlanView', {
    bindings: {
      pricePlanBundle: '<',
      selectedProgramId: '<',
      accountId: '<?'
    },
    template: require('./billing-price-plan-view.html').default,
    controller: BillingPricePlanViewComponent
  });
